import Vue from 'vue'
import Vuex from 'vuex'
import customer from '../src/store/customer'
import product from '../src/store/product'
import productsearch from '../src/store/productsearch'
import pettycash from '../src/store/pettycash'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    customer,
    product,
    productsearch,
    pettycash,
  },
  getters: {}
})